function mergeByFieldValue<T extends anyObject>(arr: Array<T>, key: keyof T, newArr: Array<T>): Array<T> {
  const tmp = arr.slice();
  newArr.forEach((item) => {
    if (!tmp.some((item2) => item2[key] === item[key])) tmp.push(item);
  });
  return tmp;
}

export { mergeByFieldValue };
